import { useEffect, useRef, useState } from 'react';
import './index.less';
import intl from '@/internationalzation/intl';
import {
  Global01NavNavmoreLineIcon,
  Global06StateWentiLineIcon,
  NewtaskLineIcon,
  Global03ActionMyagentLineIcon,
  modalConfirm,
  EmptyPicture,
  Global04TextactionShanchuLineIcon,
} from '@kim/ui';
import { Popover as AntdPopover, Tooltip } from 'antd';
import { Icon } from '@docs/kd-d2c-components';
import {
  eed_mario_icon_faker_line,
  eed_mario_icon_hammer_line,
  eed_mario_icon_skillmarket_line,
  eed_mario_icon_laboratory_line,
} from '@/assets/icons';
import newSessionIcon from '@/assets/claw/logo.png';
import { Popover } from '../popover/popover.tsx';
import { FoldButton } from '../fold-button/index.js';
import { CreateTaskButton } from '../create-task-button/index.js';
import { FloatMenuHoverContent } from './float-menu-hover-content.js';
import { useAIWindowContext } from '../../../Context/context.js';
import classNames from 'classnames';
import { AuditButton } from '../auditButton/auditButton.tsx';
import useUserInfo from '@src/stores/userModel';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getSkillsOfficialUrl,
  shouldOpenSkillsInNewTabForLocal,
} from '@src/utils/route';
import {
  isMainagentPath,
  isPathUnderBase,
  MAINAGENT_DASHBOARD_PATH,
  MAINAGENT_ROUTE_BASE,
  MAINAGENT_WORKBENCH_PATH,
} from '@src/utils/mainagent-route';
import { isMarioWebview } from '@src/utils/user-agent';
import { eed_mario_icon_sidwindow_line } from '@/assets/icons';
import { sendKimEvent } from '@/pages/pc/kim.ts';
import { KIM_EVENT } from '@/pages/pc/eventChannel.ts';
import { collectLog } from '@src/utils/logger';
import type { AgentItem } from '../../type.js';
import { useClawWs } from '@src/hooks/useClawWs';

interface IHeaderProps {
  onFoldClick: () => void;
  onTaskChange: (show: boolean) => void;
}

const isMac = true;

export const AgentPopover = (props: { agentList: AgentItem[] }) => {
  const { agentList } = props;
  const { agentClickhandler, deleteAgent, getAgentList } = useAIWindowContext();

  useEffect(() => {
    getAgentList();
  }, []);

  const deleteAgentHandler = (item: AgentItem) => {
    modalConfirm({
      okText: intl.t('Delete'),
      cancelText: intl.t('Cancel'),
      confirmBtnType: 'danger',
      content: '确定要删除该任务吗？',
      onOK: () => {
        deleteAgent(item);
      },
    });
  };
  return (
    <div className="kim-ai-mario-sidebar-agent-popover">
      <div className="kim-ai-mario-sidebar-agent-popover-header">
        <div className="kim-ai-mario-sidebar-agent-popover-header-title">
          {intl.t('mario.agent.more')}
        </div>
        <div
          className="kim-ai-mario-sidebar-agent-popover-header-more"
          onClick={() => {
            window.open('https://luigi.corp.kuaishou.com/discover', '_blank');
          }}
        >
          {intl.t('mario.market.button.aiMarket')}
        </div>
      </div>
      <div className="kim-ai-mario-sidebar-agent-popover-content">
        {agentList && agentList.length > 0 ? (
          agentList.map((item) => (
            <div
              className="kim-ai-mario-sidebar-agent-popover-content-item"
              key={item.botKwaiUserId}
              onClick={(e) => {
                e.stopPropagation();
                agentClickhandler(item);
              }}
            >
              <div className="kim-ai-mario-sidebar-agent-popover-content-item-avatar">
                <img src={item.avatarUrl} />
              </div>
              <div className="kim-ai-mario-sidebar-agent-popover-content-item-info">
                <div className="kim-ai-mario-sidebar-agent-popover-content-item-info-title">
                  {item.displayName}
                </div>
                <div className="kim-ai-mario-sidebar-agent-popover-content-item-info-description">
                  {item.description}
                </div>
              </div>
              <Global04TextactionShanchuLineIcon
                className="kim-ai-mario-sidebar-agent-popover-content-item-delete"
                size={16}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteAgentHandler(item);
                }}
              />
            </div>
          ))
        ) : (
          <div className="kim-ai-mario-sidebar-agent-popover-content-item-empty">
            <EmptyPicture>{intl.t('mario.file.null')}</EmptyPicture>
          </div>
        )}
      </div>
    </div>
  );
};

const Operations = () => {
  const { agentList } = useAIWindowContext();
  return (
    <div className="kim-ai-mario-header-operations">
      {(window as any).KIM && (
        <AntdPopover
          content={<AgentPopover agentList={agentList} />}
          trigger="hover"
          placement="rightTop"
          arrow={false}
          overlayClassName="kim-ai-mario-sidebar-bottom-popover"
          align={{
            offset: [14, -14],
          }}
        >
          <div className="kim-ai-mario-header-operations-item">
            <div className="kim-ai-mario-header-operations-item-icon">
              <Global03ActionMyagentLineIcon size={16} />
            </div>
            <div className="kim-ai-mario-header-operations-item-text">
              Agent
            </div>
          </div>
        </AntdPopover>
      )}
      <div
        className="kim-ai-mario-header-operations-item"
        onClick={() => window.open('/home', '_blank')}
      >
        <div className="kim-ai-mario-header-operations-item-icon">
          <Global06StateWentiLineIcon size={16} />
        </div>
        <div className="kim-ai-mario-header-operations-item-text">
          {intl.t('mario.copliot.sidePanel.button.learnMore')}
        </div>
      </div>
    </div>
  );
};

// 侧边栏展开时的header
export const SiderbarHeader = (props: IHeaderProps) => {
  const { onFoldClick, onTaskChange } = props;
  const { toConversion } = useAIWindowContext();
  const { switchSession } = useClawWs();
  const userInfo = useUserInfo.getState().userInfo;
  const location = useLocation();
  const navigate = useNavigate();
  const [activeModeTab, setActiveModeTab] = useState<'claw' | 'normal'>(
    'normal',
  );
  const isClawActive = isMainagentPath(location.pathname);
  const isSkillsActive =
    location.pathname === '/skills' || location.pathname.startsWith('/skills/');
  const pathNorm = location.pathname.replace(/\/$/, '') || '/';
  const isClawHomeActive = pathNorm === MAINAGENT_ROUTE_BASE;
  /** Claw 工作台高亮：支持 /mainagent/workbench 与当前 /mainagent/dashboard */
  const isClawWorkbenchActive =
    isPathUnderBase(pathNorm, MAINAGENT_WORKBENCH_PATH) ||
    isPathUnderBase(pathNorm, MAINAGENT_DASHBOARD_PATH);
  const isDigitalActive =
    location.pathname === '/lab' || location.pathname.startsWith('/lab/');
  const isAgentsActive =
    location.pathname === '/agents' || location.pathname.startsWith('/agents/');
  /** Claw 模式 Tab 高亮：含 Claw 主流程与龙虾集市（/skills） */
  const isClawModeTabActive =
    isClawActive || isSkillsActive || isDigitalActive || isAgentsActive;
  // “新建任务”只在非 Claw 模式主页高亮；历史会话详情 `/c/:id` 不应算作 Home
  const isHomeActive =
    location.pathname === '/mario' || location.pathname === '/';
  const showClawModeNav = activeModeTab === 'claw';

  useEffect(() => {
    setActiveModeTab(isClawModeTabActive ? 'claw' : 'normal');
  }, [isClawModeTabActive]);

  useEffect(() => {
    onTaskChange(!showClawModeNav);
  }, [showClawModeNav]);

  return (
    <div
      className={classNames(
        'kim-ai-mario-sidebar-header',
        isMac ? 'mac' : 'win',
      )}
    >
      <div className="kim-ai-mario-sidebar-header-top">
        <FoldButton onClick={onFoldClick} />
        <div
          className="kim-ai-mario-sidebar-header-top-title"
          onClick={() => navigate('/')}
        >
          Mario
        </div>
        {!!(window as any).KIM && isMarioWebview && (
          <Tooltip title="独立窗口打开" placement="top">
            <div
              className="kim-ai-mario-sidebar-header-top-btn"
              onClick={() =>
                sendKimEvent(
                  KIM_EVENT.OPEN_MARIO_WINDOW,
                  undefined,
                  undefined,
                  true,
                )
              }
            >
              <Icon icon={eed_mario_icon_sidwindow_line} size={16} />
            </div>
          </Tooltip>
        )}
        <AntdPopover
          content={<Operations />}
          trigger="click"
          placement="bottomRight"
          arrow={false}
          overlayClassName="kim-ai-mario-sidebar-more-popover"
        >
          <div className="kim-ai-mario-sidebar-header-top-btn">
            <Global01NavNavmoreLineIcon
              size={16}
              className="top-btn-icon more-icon"
            />
          </div>
        </AntdPopover>
      </div>
      <div className="kim-ai-mario-sidebar-mode-tabs">
        <div
          className={classNames('kim-ai-mario-sidebar-mode-tabs-item', {
            active: activeModeTab === 'claw',
          })}
          onClick={() => {
            setActiveModeTab('claw');
            switchSession('');
            navigate(MAINAGENT_ROUTE_BASE);
          }}
        >
          Mario
        </div>
        <div
          className={classNames('kim-ai-mario-sidebar-mode-tabs-item', {
            active: activeModeTab === 'normal',
          })}
          onClick={() => {
            setActiveModeTab('normal');
            toConversion('');
          }}
        >
          普通任务
        </div>
      </div>
      <div className="kim-ai-mario-sidebar-nav">
        <div
          className={classNames('kim-ai-mario-sidebar-nav-item', {
            active: showClawModeNav ? isClawHomeActive : isHomeActive,
          })}
          onClick={() => {
            if (showClawModeNav) {
              switchSession('');
              navigate(MAINAGENT_ROUTE_BASE);
              return;
            }
            toConversion('');
          }}
        >
          <NewtaskLineIcon size={20} />
          <div className="kim-ai-mario-sidebar-nav-item-text">
            <span>
              {showClawModeNav ? '新建会话' : intl.t('mario.newTask')}
            </span>
            {showClawModeNav && <img src={newSessionIcon} alt="new session" />}
          </div>
        </div>
        {showClawModeNav && (
          <div
            className={classNames('kim-ai-mario-sidebar-nav-item', {
              active: isAgentsActive,
            })}
            onClick={() => {
              navigate('/agents');
            }}
          >
            <Icon size={20} icon={eed_mario_icon_faker_line} />
            <div className="kim-ai-mario-sidebar-nav-item-text">数字员工</div>
          </div>
        )}
        {showClawModeNav && (
          <>
            <div
              className={classNames('kim-ai-mario-sidebar-nav-item', {
                active: isSkillsActive,
              })}
              onClick={() => {
                collectLog('MAIN', { action: 'PAGE_VIEW_MARKET' }, 'CLICK');
                switchSession('');
                if (shouldOpenSkillsInNewTabForLocal()) {
                  window.open(getSkillsOfficialUrl('/skills'), '_blank');
                  return;
                }
                navigate('/skills');
              }}
            >
              <Icon size={20} icon={eed_mario_icon_skillmarket_line} />
              <div className="kim-ai-mario-sidebar-nav-item-text">
                Mario 集市
              </div>
            </div>
            <div
              className={classNames('kim-ai-mario-sidebar-nav-item', {
                active: isClawWorkbenchActive,
              })}
              onClick={() => {
                navigate(MAINAGENT_DASHBOARD_PATH);
              }}
            >
              <Icon size={20} icon={eed_mario_icon_hammer_line} />
              <div className="kim-ai-mario-sidebar-nav-item-text">工作台</div>
            </div>

            <div
              className={classNames('kim-ai-mario-sidebar-nav-item', {
                active: isDigitalActive,
              })}
              onClick={() => {
                navigate('/lab');
              }}
            >
              <Icon size={20} icon={eed_mario_icon_laboratory_line} />
              <div className="kim-ai-mario-sidebar-nav-item-text">
                Mario Team
              </div>
              <span className="kim-ai-mario-sidebar-nav-item-badge">Beta</span>
            </div>
          </>
        )}
      </div>

      {userInfo?.allow_internal_audit && <AuditButton />}
    </div>
  );
};

// 折叠后的header
export const TopHeader = (props: IHeaderProps) => {
  const { onFoldClick } = props;
  const { toConversion } = useAIWindowContext();
  const { switchSession } = useClawWs();
  const location = useLocation();
  const navigate = useNavigate();

  // 折叠后header icon在同一位置，鼠标在触发位置，会导致直接显示popover
  const [canShowPopover, setCanShowPopover] = useState(false);
  const [floatMenuVisible, setFloatMenuVisible] = useState(false);
  const floatMenuTimer = useRef<NodeJS.Timeout | null>(null);

  const isClawActive = isMainagentPath(location.pathname);
  const isSkillsActive =
    location.pathname === '/skills' || location.pathname.startsWith('/skills/');
  const isDigitalActive =
    location.pathname === '/lab' || location.pathname.startsWith('/lab/');
  const isAgentsActive =
    location.pathname === '/agents' || location.pathname.startsWith('/agents/');

  const handleMouseLeaveFloatMenu = (immediate: boolean) => {
    floatMenuTimer.current && clearTimeout(floatMenuTimer.current);
    if (immediate) {
      setFloatMenuVisible(false);
    } else {
      floatMenuTimer.current = setTimeout(() => {
        setFloatMenuVisible(false);
      }, 100);
    }
  };

  const handleMouseEnterFloatMenu = (immediate: boolean) => {
    if (!canShowPopover) return;

    floatMenuTimer.current && clearTimeout(floatMenuTimer.current);
    if (immediate) {
      setFloatMenuVisible(true);
    } else {
      floatMenuTimer.current = setTimeout(() => {
        setFloatMenuVisible(true);
      }, 50);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setCanShowPopover(true);
    }, 500);
    return () => {
      floatMenuTimer.current && clearTimeout(floatMenuTimer.current);
    };
  }, []);

  return (
    <div
      className={classNames('kim-ai-window-top-header', isMac ? 'mac' : 'win')}
    >
      {/* 与展开侧栏 .kim-ai-mario-sidebar-header + .kim-ai-mario-sidebar-header-top 双层 padding 一致，保证图标位置相同 */}
      <div className="kim-ai-window-top-header__strip">
        <div className="kim-ai-window-top-header__row">
          <Popover
            content={
              <div
                className="kim-ai-mario-float-menu"
                onMouseEnter={() => handleMouseEnterFloatMenu(true)}
                onMouseLeave={() => handleMouseLeaveFloatMenu(true)}
              >
                <FloatMenuHoverContent />
              </div>
            }
            placement="bottom"
            className="kim-ai-mario-float-menu-popover"
            visible={floatMenuVisible}
            needMask={false}
            offset={[16, 16]}
          >
            <FoldButton
              tooltip={false}
              onClick={onFoldClick}
              onMouseEnter={() => handleMouseEnterFloatMenu(false)}
              onMouseLeave={() => {
                handleMouseLeaveFloatMenu(false);
              }}
            />
          </Popover>
          {!isSkillsActive && !isDigitalActive && !isAgentsActive && (
            <CreateTaskButton
              onClick={() => {
                if (isClawActive) {
                  switchSession('');
                  navigate(MAINAGENT_ROUTE_BASE);
                  return;
                }
                toConversion('');
              }}
              className="main-header-create-task-btn"
            />
          )}
        </div>
      </div>
    </div>
  );
};
